import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { ProductionGoogleAds } from './components/analytics/ProductionGoogleAds';
import App from './App';
import './index.css';
import { registerDeployRefreshListeners } from './utils/deployRefresh';
import { captureAndRestoreGoogleAdsClickIds } from './utils/googleAdsClick';

registerDeployRefreshListeners();
captureAndRestoreGoogleAdsClickIds();

registerSW({
  onNeedRefresh() {
    window.location.reload();
  },
  onOfflineReady() {},
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ProductionGoogleAds />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
